/**
 * License Price Relay Query
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const LicensePriceFragment = graphql`
  fragment licensePrice_track on TrackSearchResult {
    ...trackNode @relay(mask: false)
  }
`;

export const LicensePriceQuery = graphql`
  query licensePrice_Query($trackSlug: String, $usages: [LicenseUsageParamsInput]) {
    track(slug: $trackSlug, license_params: $usages) {
      ...licensePrice_track
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/licensePrice.ts